<template>
  <Layout class="content-sm">
    <Content style="min-height: 0!important; flex-grow: 0; padding-bottom: 0;">
      <h2 style="margin: 0">
        <p>
          <Icon type="ios-list"/>
          Sezione Contabilità
          - {{ $store.company.name }}
          - {{ $store.company.piva || $store.company.cf }}
          - {{ $d(new Date(), 'date') }}
        </p>
      </h2>
    </Content>
    <Menu theme="light" mode="horizontal" :active-name="$route.name" style="height: 40px; line-height: 40px" @on-select="goto">
      <MenuItem name="contabilita.prima-nota">Prima nota</MenuItem>
      <MenuItem name="contabilita.fatture">Fatture</MenuItem>
      <MenuItem name="contabilita.scadenzario">Scadenzario</MenuItem>
      <MenuItem name="contabilita.bilancio">Bilancio</MenuItem>
      <MenuItem name="contabilita.iva" v-if="$store.company.has_iva">Registro IVA</MenuItem>
      <MenuItem name="contabilita.contacts">Clienti &amp; Fornitori</MenuItem>
      <MenuItem name="contabilita.inventory">Beni</MenuItem>
      <MenuItem name="contabilita.ledgers">Conti</MenuItem>
      <MenuItem name="contabilita.ops">Apertura anno</MenuItem>
    </Menu>
    <Content>
      <router-view/>
    </Content>
  </Layout>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'soci-layout',
  data () {
    return {
    }
  },

  mounted () {
  },

  methods: {
    goto (name) {
      this.$router.push({name})
    }
  }
}
</script>
